import React, { type DetailedHTMLProps, type HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

import { SupText } from "../../../components/UI/Text";
import SupSearch from "../../../icons/Search";
import SupCMDK from "../../../icons/CMDK";

export function SupKBarButton({ className, ...props }: DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
  return (
    <button
      className={twMerge(
        "sup-kbar-button inline-flex items-center p-4 w-full border-0.5 border-neutral-500 bg-neutral-50 text-neutral-600 transition-colors duration-200 hover:text-primary-600 hover:bg-primary-25 hover:border-primary-700",
        className
      )}
      {...props}
    >
      <SupSearch className="mr-2" />
      <SupText variant="caption" weight="regular" className="text-neutral-600">
        SEARCH
      </SupText>
      <SupCMDK className="ml-auto" />
    </button>
  );
}
